import { HeaderTheme, setHeaderDisplay, setHeaderTheme } from '@app-components'

export const onSiteHeaderIntersectionChange = (isInView: boolean): void => {
    if (isInView) {
        setHeaderDisplay('none')
        setHeaderTheme(HeaderTheme.TRANSPARENT_WHITE)
    } else {
        setHeaderDisplay('brand-logo')
        setHeaderTheme(HeaderTheme.WHITE)
    }
}

